import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Main from "./components/Main";
import MainLogin from "./components/Login/MainLogin";
import { AuthProvider, useAuth } from "./components/contexts/AuthContext";
import { UserProvider } from "./context/UserContext";
import { ThemeProvider } from "./components/contexts/ThemeContext";
import "./App.css";
import LoadingSpinner from "./components/Universal/LoadingSpinner";

const AppRoutes = () => {
  const { isUserLoggedIn, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex flex-row gap-x-2 flex-grow justify-center items-center h-screen w-full bg-mainBg font-poppins font-light text-mainText">
        <LoadingSpinner />
        Authenticating...
      </div>
    );
  }

  return (
    <Routes>
      {isUserLoggedIn ? (
        <>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/*" element={<Main />} />
          <Route path="/login" element={<Navigate to="/home" replace />} />
        </>
      ) : (
        <>
          <Route path="/" element={<MainLogin />} />
          <Route path="/login" element={<MainLogin />} />
          <Route path="/*" element={<Navigate to="/login" replace />} />
        </>
      )}
    </Routes>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <UserProvider>
        <ThemeProvider>
          <Router>
            <AppRoutes />
          </Router>
        </ThemeProvider>
      </UserProvider>
    </AuthProvider>
  );
};

export default App;
